import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  deepLoadPlanGestionMobiliteAction,
  deepLoadPlanGestionMobiliteActionSuccessAction,
  loadPlanGestionMobilitesAction,
  loadPlanGestionMobilitesErrorAction,
  loadPlanGestionMobilitesSuccessAction,
  PlanGestionMobiliteState,
  selectIsPlanGestionMobiliteInitialized,
} from './plan-gestion-mobilite.store';
import { PgmService } from '../../_services/http/pgm.service';
import { Update } from '@ngrx/entity';
import { IPlanGestionMobilite } from '../../_models/PlanGestionMobilite';

@Injectable()
export class PlanGestionMobiliteEffect {
  constructor(
    private service: PgmService,
    private actions$: Actions,
    private store: Store<PlanGestionMobiliteState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPlanGestionMobilitesAction),
      withLatestFrom(this.store.select(selectIsPlanGestionMobiliteInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadPlanGestionMobilitesSuccessAction({ payload })),
          catchError(() => of(loadPlanGestionMobilitesErrorAction()))
        )
      )
    )
  );

  deepLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deepLoadPlanGestionMobiliteAction),
      mergeMap((action) =>
        this.service.retrieve(action.id).pipe(
          map((pgm) => {
            if (pgm) {
              // @ts-ignore
              const payload: Update<IPlanGestionMobilite> = {
                id: pgm.id,
                changes: {
                  features: pgm.features,
                  associations: pgm.associations,
                },
              };
              return deepLoadPlanGestionMobiliteActionSuccessAction({
                payload,
              });
            }

            return deepLoadPlanGestionMobiliteActionSuccessAction({
              payload: undefined,
            });
          }),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
